import type { RoleTemplate } from 'schemas';
import { RoleTemplatesApiResponseSchema } from 'schemas';
import { apiRequest } from '@/api/helpers/apiRequest';
import { handleApiError } from '@/api/helpers/handleApiError';

export const fetchRoleTemplates = async (): Promise<RoleTemplate[]> => {
  try {
    return await apiRequest(
      'GET',
      '/api/role-templates',
      undefined,
      RoleTemplatesApiResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
